import { Injectable } from '@angular/core';
import { SessionService } from '../shared/session-service/session.service';
import { API_URL } from '../shared/constants/apiurl-constants';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { File_TYPE } from '../shared/constants/app-constants';
import { BaseResponse } from '../shared/models/base-response.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { IFavoriteStudies } from './models/study.model';

@Injectable({ providedIn: 'root' })
export class HomeService {
  clientSwitchObservable: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private sessionService: SessionService, private httpClient: HttpClient) {

  }

  GetAllEngagements(): Observable<BaseResponse> {
    // return this.sessionService.apiUrlGet<BaseResponse>(API_URL.ENGAGEMENT.GETALLENGAGEMENTS);

    const apiUrl = `${environment.webApiDefaultRoot}Engagement/GetAllEngagements`;
    return this.httpClient.get<BaseResponse>(apiUrl);
  }

  getEngagementBySearchText(searchBy: string, isArchived: boolean) {
    const apiUrl = `${environment.webApiDefaultRoot}Engagement/GetEngagementBySearchText?searchBy=${searchBy}&isArchived=${isArchived}`;
    return this.httpClient.get(apiUrl);
  }

  getFavoriteStudies(): Observable<IFavoriteStudies[]> {
    const apiUrl = `${environment.webApiDefaultRoot}Engagement/GetFavoriteStudies`;
    return this.httpClient.get<IFavoriteStudies[]>(apiUrl);
  }

  GetClientsByUser() {
    return this.sessionService.apiUrlGet(API_URL.CLIENT.GET_BY_USER);
  }

  GetEngagementsByClientId(clientId: number, isArchieved: boolean) {
    return this.sessionService.apiUrlGet(
      API_URL.ENGAGEMENT.GET_BY_CLIENT_ID + '?clientId=' + clientId + '&IsArchived=' + isArchieved
    );
  }

  GetEngagementsByUserId(isArchieved: Boolean) {
    return this.sessionService.apiUrlGet(
      API_URL.ENGAGEMENT.GETENGAGEMENTBYUSERID + '?IsArchived=' + isArchieved,
    );
  }

  GetEngagementsByClientName(clientName: string, IsArchived: boolean) {
    return this.sessionService.apiUrlGet(
      API_URL.ENGAGEMENT.GETENGAGEMENTSBYCLIENTNAME +
      '?clientName=' +
      clientName +
      '&IsArchived=' +
      IsArchived,
    );
  }

  GetReleaseNotesDownload() {
    let downloadFileTypeRequest = { downloadFileType: File_TYPE.RELEASE_NOTES };
    return this.sessionService.downloadAsFile(API_URL.REPORTS.DOWNLOADFILES, downloadFileTypeRequest);
  }

  GetReleaseHistoryDownload() {
    let downloadFileTypeRequest = { downloadFileType: File_TYPE.RELEASE_HISTORY };
    return this.sessionService.downloadAsFile(API_URL.REPORTS.DOWNLOADFILES, downloadFileTypeRequest);
  }

  GetUserNotifiedDetail() {
    return this.sessionService.apiUrlGet(API_URL.CLIENT.GET_USER_NOTIFIED_DETAIL);
  }

  UpdateUserNotifiedDetail() {
    return this.sessionService.apiUrlPost(API_URL.CLIENT.UPDATE_USER_NOTIFIED_DETAIL, {});
  }

  GetEngagementById(engagementId: number, updateRecentlyViewedEngagement: boolean = false) {
    return this.sessionService.apiUrlGet(
      API_URL.ENGAGEMENT.GETENGAGEMENTBYID + '?engagementId=' + engagementId +
      '&updateRecentlyViewedEngagement=' + updateRecentlyViewedEngagement,
    );
  }

  GetEngagementBasic(engagementId: number) {
    return this.sessionService.apiUrlGet(
      API_URL.ENGAGEMENT.GETENGAGEMENTBASIC + '?engagementId=' + engagementId,
    );
  }

  UpdateUserMode(isClientMode: boolean): Observable<any> {
    let updateExternalModeRequest = { isExternalMode: isClientMode };
    return this.sessionService.apiUrlPost(API_URL.CLIENT.UPDATE_USER_MODE, updateExternalModeRequest);
  }
  updateLoginAsClient(isLoginAsClient: boolean): Observable<any> {
    let viewAsClientManagerRequest = { isViewAsClientManager: isLoginAsClient }
    var result = this.sessionService.apiUrlPost(API_URL.CLIENT.UPDATE_LOGIN_AS_CLIENT, viewAsClientManagerRequest);
    this.clientSwitchObservable.next(isLoginAsClient);
    return result;
  }
}
